import React, { ReactElement } from 'react';

import { TextBodySmall } from '../../components/Text';
import TInputLabel from './TInputLabel';

const InputLabel = ({ htmlFor, isInputRequired, labelText, optionalText }: TInputLabel): ReactElement => (
  <>
    <TextBodySmall as="label" color="text-primary" strong={true} htmlFor={htmlFor} className="input-label">
      {labelText}
      {!isInputRequired && optionalText && (
        <TextBodySmall as="span" color="text-secondary" utilities={['marginLeftXxxs']}>
          {`(${optionalText})`}
        </TextBodySmall>
      )}
    </TextBodySmall>
  </>
);

export default InputLabel;
